/*!
 * fuzz.js — fuzz:{...}: a fuzz pedal on a dying battery, in a synth's voice
 * © 2026 Rob Canning — GPLv3
 *
 *     fuzz:0.7                                  how starved: 0 healthy .. 1 nearly dead
 *     fuzz:{starve:0.8, gain:60, bias:0.5, tone:1800}
 *
 *   starve  0..1 (0.5)  the supply: the more starved, the lower and saggier
 *                       the rails, the wider the dead zone (gated, splatty),
 *                       the more it wobbles and crackles
 *   gain    1..200 (30) how hard it is driven
 *   bias    0..1 (0.3)  how far off centre: uneven, buzzier
 *   tone    Hz (2500)   warmth: lowpassed above it
 *
 * Before the envelope, after sub: and drive: (synth.js). The sound is
 * fuzzCore.js, run in the audio engine by fuzzWorklet.js (workletFx.js:
 * a voice made before the engine has it plays clean until it does).
 */

import { fuzzSettings } from "./fuzzCore.js";
import { loadWorklet, buildWorkletFx } from "./workletFx.js";

const URL_ = new URL("./fuzzWorklet.js", import.meta.url).href;

/** Load the fuzz into this context's audio engine (once). */
export const loadFuzz = ctx => loadWorklet(ctx, URL_);

/** A fuzz for one voice (or, channels 2, an fx bus): { input, output, set(cfg), stop() }. */
export function buildFuzz(ctx, cfg, channels = 1) {
  const fx = buildWorkletFx(ctx, { processor: "oscilla-fuzz", url: URL_, settings: fuzzSettings(cfg), channels });
  return { ...fx, set: c => fx.set(fuzzSettings(c)) };
}
